import * as React from "react";
import { RefreshCw } from "react-feather";
import { Button } from "antd";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { fetchHealth, fetchUsageMetrics, selectUsageDateRange } from "../../store/healthSlice";
import { LastUpdated } from "../../components/LastUpdated";

function getDebug() {
  return (localStorage.getItem("CPLN_DEBUG") || "") === "true";
}

interface Props {}
export const HealthHeader: React.FC<Props> = ({}) => {
  const dispatch = useAppDispatch();
  const org = useAppSelector(selectOrg);
  const isLoading = useAppSelector((state) => state.health.isLoading);
  const isFetched = useAppSelector((state) => state.health.isFetched);
  const [debug] = React.useState(getDebug);
  const requestTime = useAppSelector((state) => state.health.requestTime);
  const totalRequestCount = useAppSelector((state) => state.health.totalRequestCount);
  const fullfillTime = useAppSelector((state) => state.health.fullfillTime);
  const usageDateRange = useAppSelector(selectUsageDateRange);

  const handleRefresh = () => {
    dispatch(fetchHealth());
    if (org) {
      dispatch(fetchUsageMetrics({ orgName: org, dateRange: usageDateRange }));
    }
  };

  return (
    <>
      <div className="n-detail-header flex items-center justify-between pb-4 h-20 z-10">
        <div>
          <div data-testid="detail-kind" className="text-dark text-xs">
            Org Health Dashboard
          </div>
          <div className="flex items-center">
            <div data-testid="detail-name" className="text-2xl font-semibold leading-none">
              {org}
            </div>
          </div>
        </div>
        {debug && (
          <div className="ml-6 text-xs" style={{ color: "var(--color-label)" }}>
            {requestTime} ms | {totalRequestCount} reqs
          </div>
        )}
        <div className="flex-grow" />
        <div className="flex items-center gap-2">
          {isFetched ? <LastUpdated timestamp={fullfillTime} /> : null}
          <Button onClick={handleRefresh} loading={isLoading} icon={<RefreshCw size={14} />} iconPosition="end">
            Refresh
          </Button>
        </div>
      </div>
    </>
  );
};
